import getDomains from '@/utils/getDomains'
export default function useIsEdu() {
  const isEdu = getDomains().thirdLevelDomain === 'edu'
  return {
    isEdu
  }
}
